import axios from "axios"

export default {
	user: null,

	login(username, password) {
		return new Promise((resolve, reject) => {
			axios
				.post("/v1/login", {
					email: username,
					password: password
				})
				.then(data => {
					console.log("POST LOGIN", data);
					this.setToken(data.data.data);
					resolve(data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setUserAccount(data) {
		return axios.post("v1/user_account", data);
	},

	setUserPassword(id, password) {
		var ctx = {
			user_id: id,
			password: password,
		}
		return axios.post(`/v1/user/user_password`, ctx)
	},

	setToken(token) {

		console.log("setting token", token);
		//We don't really have to store the token, we'll use the "oscar" cookie until we see reasons otherwise
		this.token = token;
		//It seems like any requests that happen within this resolve do not carry the cookie so we'll set this here. Cookie will be used on page refresh
		axios.defaults.headers.common["X-Auth-Token"] = this.token;
	},

	logout() {
		this.user = null
	},

	changeSection(sectionID) {
		return axios.post(`/v1/change_section/${sectionID}`)
	}
}